var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#7029a3",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.3588 10.43c-0.69227 1.2648-0.69227 2.7904-0.69227 5.8416v2.0281c0 5.2011 0 7.8018 1.5621 9.4175 1.5621 1.6159 4.0762 1.6159 9.1046 1.6159h5.3333c5.0283 0 7.5425 0 9.1045-1.6159 1.5622-1.6157 1.5622-4.2164 1.5622-9.4175v-2.0281c0-3.0512 0-4.5768-0.6923-5.8416-0.6923-1.2647-1.9569-2.0496-4.4864-3.6194l-2.6667-1.655c-2.6738-1.6594-4.0108-2.4892-5.488-2.4892s-2.8141 0.82972-5.4879 2.4892l-2.6667 1.655c-2.5294 1.5698-3.7942 2.3548-4.4864 3.6194zm11.641 13.57c0 0.5523 0.4478 1 1 1 0.5523 0 1-0.4477 1-1v-4c0-0.5522-0.4477-1-1-1-0.5522 0-1 0.4478-1 1v4z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon_home.a119280abc5c199b027065fb89c04f15.svg";
export { ForwardRef as ReactComponent };